export default __webpack_public_path__ + "static/media/sponsor-icon.1425ad86.webp";